















































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import {
  getDishPage,
  editDish,
  deleteDish,
  dishStatusByStatus,
  dishCategoryList,
  setFlashSale, // <--- 加这一句
  deleteFlashSale, // <--- 新增
  getFlashSaleInfo
} from '@/api/dish'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import Empty from '@/components/Empty/index.vue'
import { baseUrl } from '@/config.json'

@Component({
  name: 'DishType',
  components: {
    HeadLable,
    InputAutoComplete,
    Empty
  }
})
export default class extends Vue {
  private input: any = ''
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private checkList: string[] = []
  private tableData: [] = []
  private dishState = ''
  private dishCategoryList = []
  private categoryId = ''
  private dishStatus = ''
  private isSearch: boolean = false
  private saleStatus: any = [
    {
      value: 0,
      label: '停售'
    },
    {
      value: 1,
      label: '启售'
    }
  ]
  //秒杀相关变量
  private flashSaleDialogVisible = false
  private flashSaleForm = {
    voucherId: '',
    name: '',
    originalPrice: 0,
    price: '',
    stock: '',
    timeRange: [] as string[],
    isEdit: false, // 标记是新建还是修改
    currentStock: 0 // Redis里的实时库存
  }
  
  created() {
    this.init()
    this.getDishCategoryList()
  }

  initProp(val) {
    this.input = val
    this.initFun()
  }

  initFun() {
    this.page = 1
    this.init()
  }

  private async init(isSearch?) {
    this.isSearch = isSearch
    await getDishPage({
      page: this.page,
      pageSize: this.pageSize,
      name: this.input || undefined,
      categoryId: this.categoryId || undefined,
      status: this.dishStatus
    })
      .then(res => {
        if (res.data.code === 1) {
          this.tableData = res.data && res.data.data && res.data.data.records
          this.counts = Number(res.data.data.total)
        }
      })
      .catch(err => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  // 添加
  private addDishtype(st: string) {
    if (st === 'add') {
      this.$router.push({ path: '/dish/add' })
    } else {
      this.$router.push({ path: '/dish/add', query: { id: st } })
    }
  }

  // 删除
  private deleteHandle(type: string, id: any) {
    if (type === '批量' && id === null) {
      if (this.checkList.length === 0) {
        return this.$message.error('请选择删除对象')
      }
    }
    this.$confirm('确认删除该菜品, 是否继续?', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteDish(type === '批量' ? this.checkList.join(',') : id)
        .then(res => {
          if (res && res.data && res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }
  //获取菜品分类下拉数据
  private getDishCategoryList() {
    dishCategoryList({
      type: 1
    })
      .then(res => {
        if (res && res.data && res.data.code === 1) {
          this.dishCategoryList = (
            res.data &&
            res.data.data &&
            res.data.data
          ).map(item => {
            return { value: item.id, label: item.name }
          })
        }
      })
      .catch(() => {})
  }

  //状态更改
  private statusHandle(row: any) {
    let params: any = {}
    if (typeof row === 'string') {
      if (this.checkList.length === 0) {
        this.$message.error('批量操作，请先勾选操作菜品！')
        return false
      }
      params.id = this.checkList.join(',')
      params.status = row
    } else {
      params.id = row.id
      params.status = row.status ? '0' : '1'
    }
    this.dishState = params
    this.$confirm('确认更改该菜品状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      // 起售停售---批量起售停售接口
      dishStatusByStatus(this.dishState)
        .then(res => {
          if (res && res.data && res.data.code === 1) {
            this.$message.success('菜品状态已经更改成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  // 全部操作
  private handleSelectionChange(val: any) {
    let checkArr: any[] = []
    val.forEach((n: any) => {
      checkArr.push(n.id)
    })
    this.checkList = checkArr
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }


// 【新增】打开秒杀弹窗 
  private handleFlashSale(row: any) {
    const isEditing = row.isFlashSale === 1;
    this.flashSaleForm = {
      voucherId: row.id,
      name: row.name,
      originalPrice: row.price,
      price: isEditing ? row.flashSalePrice : '', // 回显价格
      stock: isEditing ? row.flashSaleStock : '100', // 回显库存或默认
      timeRange: row.flashSaleTimeStr ? row.flashSaleTimeStr.split(',') : [],
      isEdit: isEditing,
      currentStock: row.flashSaleStock || 0
    }
   // 2. 如果是正在进行中的活动，立即发起请求获取【最新库存】
    if (isEditing) {
        getFlashSaleInfo(row.id).then(res => {
            if (res.data.code === 1) {
                const data = res.data.data;
                // 更新弹窗里的实时库存显示
                this.flashSaleForm.currentStock = data.stock;
                this.flashSaleForm.stock = data.stock;        // 更新输入框
                // this.flashSaleForm.stock = data.stock; 
            }
        })
    }

    this.flashSaleDialogVisible = true
  }

 // 结束活动
private handleStopFlashSale() {
  this.$confirm('确定要结束该商品的秒杀活动吗？库存将清零，活动立即停止。', '警告', {
    type: 'warning'
  }).then(() => {
    deleteFlashSale(this.flashSaleForm.voucherId).then((res: any) => {
      if (res.data.code === 1) {
        this.$message.success('活动已结束');
        this.flashSaleDialogVisible = false;
        this.init(); // 刷新列表，按钮变蓝
      }
    })
  })
}

// 【新增】提交秒杀
private submitFlashSale() {
    // 简单校验
    if (!this.flashSaleForm.price || !this.flashSaleForm.stock || !this.flashSaleForm.timeRange) {
      this.$message.warning('请填写完整信息')
      return
    }

    const params = {
      voucherId: this.flashSaleForm.voucherId,
      stock: this.flashSaleForm.stock,
      price: this.flashSaleForm.price,
      beginTime: this.flashSaleForm.timeRange[0],
      endTime: this.flashSaleForm.timeRange[1]
    }

    // 使用 api/dish.ts 里定义的方法
    setFlashSale(params).then((res: any) => {
      if (res.data.code === 1) {
        this.$message.success('秒杀活动设置成功！')
        this.flashSaleDialogVisible = false
        // 设置成功后刷新一下列表
        this.init() 
      } else {
        this.$message.error(res.data.msg || '设置失败')
      }
    }).catch(err => {
      this.$message.error('请求出错了：' + err.message)
    })
  }


}
